import { IStoreEntityStateSlice, createEntitySlice } from '@aston/foundation';
import { ISubsidiaryListItem } from 'apps/console/src/app/subsidiaries-module/models';

export interface ISubsidiariesState {
	subsidiaries: IStoreEntityStateSlice<ISubsidiaryListItem[]>;
	hasPendingItems: boolean;
	hasLoadedOnce: boolean;
}

export const initialState: ISubsidiariesState = {
	hasPendingItems: false,
	hasLoadedOnce: false,
	subsidiaries: createEntitySlice({ entity: [] })
};
